import { Facebook, Github, Globe, Linkedin, Mail, MessageCircle } from 'lucide-react';

// Dane autora pokazywane w stopce ekranu logowania.
//
// ==========================================================================
//  TUTAJ UZUPEŁNIASZ SWOJE DANE — to jedyne miejsce, nic więcej nie trzeba
//  ruszać. Pozycje z pustym `href` / `copyValue` po prostu się nie pokazują,
//  więc możesz uzupełniać je pojedynczo, a karta nigdy nie wygląda na zepsutą.
// ==========================================================================
//
// Dwa rodzaje pozycji:
//   href      — zwykły odnośnik, otwiera się w nowej karcie (GitHub, Facebook…)
//   copyValue — wartość do skopiowania, nie adres (WeChat to identyfikator,
//               a nie URL, więc kliknięcie kopiuje go do schowka)
//
// Ikony pochodzą z lucide-react; dostępne m.in.: Github, Facebook, Linkedin,
// Instagram, Twitter, Youtube, Mail, Globe, MessageCircle, Phone, Send.

export const AUTHOR = {
  name: 'Kamil Rychlik',
  tagline: 'Designed & Coded',
  role: 'Projekt i wykonanie aplikacji',
  copyrightFrom: 2025,
  copyrightTo: 2026,

  links: [
    { id: 'github', label: 'GitHub', handle: '', href: '', icon: Github },
    { id: 'linkedin', label: 'LinkedIn', handle: '', href: 'https://www.linkedin.com/in/kamil-rychlik-5b954a284/', icon: Linkedin },
    { id: 'facebook', label: 'Facebook', handle: '', href: '', icon: Facebook },
    { id: 'wechat', label: 'WeChat', handle: '', copyValue: '', icon: MessageCircle },
    { id: 'email', label: 'E-Mail', handle: 'k.rychlik99@gmail.com', href: 'mailto:k.rychlik99@gmail.com', icon: Mail },
    { id: 'www', label: 'Strona', handle: '', href: '', icon: Globe },
  ],
};

/** Tylko pozycje faktycznie uzupełnione — reszta nie trafia do interfejsu. */
export const authorLinks = () =>
  AUTHOR.links.filter((link) => Boolean(link.href) || Boolean(link.copyValue));
